<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Am5v4g/tc-custom/9780795350979.jpg?1737157722041" alt="This image is the cover for the book Japanese Baseball"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Japanese Baseball
      </h1>
      <p class="bookDescription body article font2">
        <b>Short stories filled with empathy, laughter, and a love of the game, from the award-winning author of <i>Shoeless Joe</i>.</b><br/>  <br/> W.P. Kinsella weaves his characters into the thrill of the game, be it in Japan, Central America, Canada, or the United States, with a variety of comic, tragic, and mystical results. This collection captures the dazzling wit, compelling insight, and obsession with baseball that have made Kinsella more popular than a ballpark frank.<br/>  <br/> “There is a new depth and gentleness to Kinsella’s storytelling here, a more subtle nuance than his readers may be accustomed to. In ‘The Kowloon Club,’ the baseball club is persuaded to hire a Feng Shui master to determine the site for their new park…‘The First and Last Annual Six Towns Old-Timers’ Game’ is vintage Kinsella…The final extra-base hit is a deeply felt, introspective look at the half-lived life of an umpire and the reasons he continues to be a part of the game, even when his marriage is going foul.”—<i>Quill &amp; Quire</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W. P. Kinsella
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?132156ae